import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ENVIRONMENT } from '@front/shared/util-environment';
import { Observable } from 'rxjs';
import { EuaPriceEntry, EuaPriceListResponse } from '../models/backend';

Injectable({ providedIn: 'root' });
export class PriceService {
  private http = inject(HttpClient);
  private environment = inject(ENVIRONMENT);

  getHistory(days: number | null = null): Observable<EuaPriceEntry[]> {
    return this.http.get<EuaPriceEntry[]>(
      `${this.environment.cmsApiUrl}/eua-price/history${days ? `?days=${days}` : ''}`,
    );
  }

  getLast(): Observable<EuaPriceListResponse> {
    return this.http.get<EuaPriceListResponse>(
      `${this.environment.cmsApiUrl}/eua-prices?pagination[page]=1&pagination[pageSize]=1&sort=createdAt:desc`,
    );
  }
}
